import React, { HTMLAttributes, StyleHTMLAttributes } from 'react';

interface Props {
  style?: HTMLAttributes<'div'>['style'];
  padding?: number | string;
}

export const Padding: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { children, padding = 16, style = {} } = props;

  return <div style={{ padding: typeof padding === 'number' ? padding + 'px' : padding, ...style }}>{children}</div>;
};
